import {QuoteService} from 'quote-domain-core';
import { container } from 'tsyringe';
import { QuoteServiceCommercialService } from '../service/quote-service/quote-service-commercial-service';
import { QuoteServiceCorridorPipelineService } from '../service/quote-service/quote-service-corridor-pipeline-service';
import { QuoteServiceLifecycleService } from '../service/quote-service/quote-service-lifecycle-service';
import { QuoteServiceRecommendedConsumableService } from '../service/quote-service/quote-service-recommended-consumable-service';
import { QuoteServiceSetupService } from '../service/quote-service/quote-service-setup-service';

export enum PricingModeEnum {
    FIXED_PRICE = 'FIXED_PRICE',
    FIXED_CORRIDOR = 'FIXED_CORRIDOR'
}

export abstract class AbstractServiceCalculator {

    protected readonly corridorPipelineService = container.resolve(QuoteServiceCorridorPipelineService);
    protected readonly lifecycleService = container.resolve(QuoteServiceLifecycleService);
    protected readonly setupService = container.resolve(QuoteServiceSetupService);
    protected readonly commercialService = container.resolve(QuoteServiceCommercialService);
    protected readonly recommendedConsumableService: QuoteServiceRecommendedConsumableService;

    constructor(public quoteService: QuoteService,
                public referential: any,
                public referentialServices: any,
                public mergeQuantity: boolean,
                public canChangePricingItemPrice: boolean,
                public pricingMode: PricingModeEnum,
                recommendedConsumableService: QuoteServiceRecommendedConsumableService = container.resolve(QuoteServiceRecommendedConsumableService)) {
        this.recommendedConsumableService = recommendedConsumableService;
    }

    abstract execute(): void;


}

